import React, { useState } from 'react';
import { Header } from '../components/Header';
import { StatsOverview } from '../components/StatsOverview';
import { ModuleGrid } from '../components/ModuleGrid';
import { AlertsPanel } from '../components/AlertsPanel';
import { LiveMap } from '../components/LiveMap';
import { QuickActions } from '../components/QuickActions';
import { PerformanceChart } from '../components/PerformanceChart';
import { ModuleDetailModal } from '../components/ModuleDetailModal';
export function Dashboard() {
  const [selectedModule, setSelectedModule] = useState<string | null>(null);
  const [timePeriod, setTimePeriod] = useState('today');
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-755">
      <Header onTimePeriodChange={setTimePeriod} currentPeriod={timePeriod} data-id="element-756" />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-757">
        {/* Stats Overview */}
        <StatsOverview period={timePeriod} data-id="element-758" />
        {/* Quick Actions */}
        <QuickActions data-id="element-759" />
        {/* Main Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-8" data-id="element-760">
          {/* Left Column */}
          <div className="lg:col-span-2 space-y-6" data-id="element-761">
            <ModuleGrid onModuleClick={setSelectedModule} data-id="element-762" />
            <PerformanceChart data-id="element-763" />
          </div>
          {/* Right Column */}
          <div className="space-y-6" data-id="element-764">
            <AlertsPanel data-id="element-765" />
            <LiveMap data-id="element-766" />
          </div>
        </div>
      </main>
      {/* Module Detail Modal */}
      {selectedModule && <ModuleDetailModal module={selectedModule} onClose={() => setSelectedModule(null)} data-id="element-767" />}
    </div>;
}